import SendDisconnectedAccountEmailPrompt from './SendDisconnectedAccountEmailPrompt';
import { connect } from 'react-redux';
import { sendDisconnectedAccountEmail } from '../../actions/sendDisconnectedAccountEmail';
const mapDispatchToProps = {
  sendDisconnectedAccountEmail
};
export default connect(null, mapDispatchToProps)(SendDisconnectedAccountEmailPrompt);